
import { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";

interface LoginFormProps {
  onSuccess?: () => void;
  onClose: () => void;
}

export const AuthModalLoginForm = ({ onSuccess, onClose }: LoginFormProps) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login } = useAuth();
  const { toast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      console.log("AuthModalLoginForm: Login attempt for", email);
      await login(email, password);
      
      toast({
        title: "Login successful",
        description: "Welcome back to RedFlags"
      });
      
      console.log("AuthModalLoginForm: Login successful, calling onSuccess callback");
      
      // Give a very small delay to ensure auth state updates before callback execution
      setTimeout(() => {
        if (onSuccess) {
          onSuccess();
        }
        onClose();
      }, 50);
      
    } catch (error: any) {
      console.error("Login error in modal:", error);
      toast({
        title: "Login failed",
        description: error.message,
        variant: "destructive"
      });
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid gap-2">
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="name@example.com"
          required
        />
      </div>
      <div className="grid gap-2">
        <Label htmlFor="password">Password</Label>
        <Input
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="••••••••"
          required
        />
      </div>
      
      <Button type="submit" className="w-full" disabled={loading}>
        {loading ? (
          <span className="flex items-center gap-2">
            <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
            Logging in...
          </span>
        ) : (
          'Log in'
        )}
      </Button>
    </form>
  );
};
